import { forwardRef, AnchorHTMLAttributes } from 'react';

interface SkipLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: string;
}

/**
 * Accessible Skip Link Component
 * Provides keyboard navigation to main content
 * WCAG 2.1 Level A Compliance
 */
export const SkipLink = forwardRef<HTMLAnchorElement, SkipLinkProps>(
  ({ href, children, className = '', ...props }, ref) => {
    return (
      <a
        ref={ref}
        href={href}
        className={`sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary-600 focus:text-white focus:rounded-lg focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 min-h-touch ${className}`}
        {...props}
      >
        {children}
      </a>
    );
  }
);

SkipLink.displayName = 'SkipLink';
